export const LargeTextBox = ({name,placeholder,onChange,value}) => {
   return (
    <div className="text-box-container">
        <textarea 
            className="text-area-input"
            name={name}
            value={value}
            placeholder={placeholder}
            onChange={onChange} 
        />
    </div>
   )
}